import { render, staticRenderFns } from "./bindStraegy.vue?vue&type=template&id=2a0303ce&scoped=true"
import script from "./bindStraegy.vue?vue&type=script&lang=js"
export * from "./bindStraegy.vue?vue&type=script&lang=js"
import style0 from "./bindStraegy.vue?vue&type=style&index=0&id=2a0303ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0303ce",
  null
  
)

export default component.exports